import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const FormGroup = ({ label, labelProps, labelAsTitle, description, descriptionProps, className, errorMessage, errorMessageProps, children, ...props }) => {
    const intl = useIntl();
    return (
        <div className={['govuk-form-group', className, (errorMessage ? 'govuk-form-group--error' : null)].join(' ')} data-testid={props['data-testid'] ? props['data-testid'] : null}>
            {label && <div className="govuk-label-wrapper">
                <label
                    { ...labelProps }
                    data-testid={props['data-testid'] ? props['data-testid'] + '-label' : null}
                    className={['govuk-label', labelAsTitle ? 'govuk-label--l' : null].join(' ')}
                >
                    {label}
                </label>
            </div>}
            {description && (
                <div { ...descriptionProps } data-testid={ props['data-testid'] ? props['data-testid'] + '-hint' : null } className='govuk-hint'>
                    {description}
                </div>
            )}
            {errorMessage && (
                <p { ...errorMessageProps } data-testid={ props['data-testid'] ? props['data-testid'] + '-error' : null } className='govuk-error-message'>
                    <span className='govuk-visually-hidden'>{intl.formatMessage({ id: 'errorLabel' })}:</span> {errorMessage}
                </p>
            )}
            {children}
        </div>
    );
};

FormGroup.propTypes = {
    id: PropTypes.string,
    labelProps: PropTypes.object,
    errorMessageProps: PropTypes.object,
    descriptionProps: PropTypes.object,
    label: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    description: PropTypes.string,
    value: PropTypes.string,
    enableSpellCheck: PropTypes.bool,
    errorMessage: PropTypes.string,
    'data-testid': PropTypes.string,
    children: PropTypes.element,
    className: PropTypes.string
};

FormGroup.defaultProps = {
    enableSpellCheck: true,
    labelAsTitle: false,
    width: 'full',
    inputMode: 'text',
    className: ''
};

export default FormGroup;
